export const environment = {
  production: true,
  APP_ID: '1ea1028a-1da4-42ea-a803-abc4a2b008b0',
  API_BASE_URL: 'https://promo.united.com/offers/api/acceleratorpromo',
  IMAGE_BASE_URL: 'https://promo.united.com/chaseacceleratorpromo/public/images/',
  ASSETS_BASE_URL: 'https://promo.united.com/assets/img/',
};